import EmblaCarousel from 'embla-carousel';
import AutoHeight from 'embla-carousel-auto-height';
import Fade from 'embla-carousel-fade';
import { addThumbsClicks, addToggleThumbActive } from '../utils/embla-utils';

const tabs = document.querySelectorAll('.tabs');

const initCarousels = (content, navigation) => {
  const emblaApiMain = EmblaCarousel(content, {}, [Fade(), AutoHeight()]);
  const emblaApiThumb = EmblaCarousel(navigation, {
    containScroll: 'keepSnaps',
    dragFree: true,
  });

  addThumbsClicks(emblaApiMain, emblaApiThumb);
  addToggleThumbActive(emblaApiMain, emblaApiThumb);
};

(() => {
  if (tabs.length > 0) {
    tabs.forEach((t) => {
      const tabsContentNode = t.querySelector('.tabs-content .embla__viewport');
      const tabsNavigationNode = t.querySelector('.embla-thumbs__viewport');

      if (tabsContentNode && tabsNavigationNode) {
        // this can be heavy. but height doesn't get the correct
        // values if loaded before.
        // for some reason, reinit does nothing
        // @todo figure out better way when time/money
        setTimeout(() => {
          initCarousels(tabsContentNode, tabsNavigationNode);
        }, 500);
      }
    });
  }
})();
